var exports = {
  "k": "x31de4314--c734f1--container",
};

module.exports = exports;
